import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Sgke131aResponseReceivemoneyyoteiMeisaiList } from 'sg-api';

@Component({
  selector: 'app-sgke130d-receivemoneyyotei-meisai',
  templateUrl: './sgke130d-receivemoneyyotei-meisai.component.html',
  styleUrl: './sgke130d-receivemoneyyotei-meisai.component.scss'
})
export class Sgke130dReceivemoneyyoteiMeisaiComponent implements OnInit, OnDestroy {
  /** 入金予定明細リスト */
  @Input() receivemoneyyoteiMeisaiList: Array<Sgke131aResponseReceivemoneyyoteiMeisaiList>;
  /** データソース */
  dataSource: MatTableDataSource<Sgke131aResponseReceivemoneyyoteiMeisaiList>;

  /** テーブル表示カラム */
  displayedColumnsCol: string[] = [
    'kouzaRcvmnyFclt',
    'incYmd',
    'rcvmnyNumber',
    'inshitaxwothFeeTargetcount',
    'receivemoneyyoteiMny',
    'energysystemCode'
  ];

  /**
   * 初期処理
   * 
   * @memberof Sgke130dReceivemoneyyoteiMeisaiComponent
   */
  ngOnInit(): void {
    // Table表示データ作成
    this.dataSource = new MatTableDataSource<Sgke131aResponseReceivemoneyyoteiMeisaiList>(this.receivemoneyyoteiMeisaiList);
  }

  /**
   * コンポーネントが破棄される際に呼び出されるライフサイクルフック
   * リソースの解放や購読の解除
   * 
   * @memberof Sgke130dReceivemoneyyoteiMeisaiComponent
   */
  ngOnDestroy(): void {
  }

}
